export const SORT_DIRECTIONS = {
    NONE: "none",
    ASC: 0,
    DESC: 1
}